import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import DTCustomerAccountView from '../../DTCustomerAccountView';
import { getSelectedCustomer } from '../../../../../../selectors/tools';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';

const DTSelectCustomerNode = () => {
  const dispatch = useDispatch();
  const selectedCustomer = useSelector(getSelectedCustomer);

  const handleNextButtonClick = () => dispatch(addEdgeToDecisionTreePath('customer_selected'));

  return (
    <DTCustomerAccountView onNextButtonClick={handleNextButtonClick} isNextButtonActive={!isEmpty(selectedCustomer)} />
  );
};

export default DTSelectCustomerNode;
